import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'mwo-progress-dialog',
  templateUrl: './progress-dialog.component.html',
  styleUrls: ['./progress-dialog.component.scss']
})
export class ProgressDialogComponent implements OnInit {

  @Input() current: number;
  @Input() total: number;
  @Input() message: string;

  progress: number;

  constructor() { }

  ngOnInit(): void {
    this.progress = (this.current * 100) / this.total ;
  }

}
